module.exports = __webpack_public_path__ + "img/james.004917b6.jpg";